/**
 * Constants for the New Kanban Board implementation
 */

// Stage IDs - ensure these match exactly with backend values
export const STAGE_IDS = {
  LEAD_IN: 'stage_lead_in',
  NURTURE: 'stage_nurture',
  PROPOSAL_NEEDED: 'stage_proposal_needed',
  FIX_MEETING: 'stage_fix_meeting',
  CLOSED_WON: 'stage_closed_won',
  CLOSED_LOST: 'stage_closed_lost',
};

// Ordered list of stages for consistent display
export const STAGE_ORDER = [
  STAGE_IDS.LEAD_IN,
  STAGE_IDS.NURTURE,
  STAGE_IDS.PROPOSAL_NEEDED,
  STAGE_IDS.FIX_MEETING,
  STAGE_IDS.CLOSED_WON,
  STAGE_IDS.CLOSED_LOST,
];

// Initial stage expansion state
export const INITIAL_EXPANDED_STAGES = {
  [STAGE_IDS.LEAD_IN]: true,
  [STAGE_IDS.NURTURE]: true,
  [STAGE_IDS.PROPOSAL_NEEDED]: true,
  [STAGE_IDS.FIX_MEETING]: true,
  [STAGE_IDS.CLOSED_WON]: false, // Collapsed by default
  [STAGE_IDS.CLOSED_LOST]: false, // Collapsed by default
};

// Used to identify closed stages for special handling
export const CLOSED_STAGE_IDS = [
  STAGE_IDS.CLOSED_WON,
  STAGE_IDS.CLOSED_LOST,
];

/**
 * Check if a stage ID is for a closed stage
 * @param {string} stageId - The stage ID to check
 * @returns {boolean} - True if closed stage
 */
export const isClosedStage = (stageId) => CLOSED_STAGE_IDS.includes(stageId);
